import { AnimatePresence, motion } from 'framer-motion';
var fadeUp = {
    hidden: {
        y: '100%',
        opacity: 0,
    },
    show: {
        y: '0',
        opacity: 1,
    },
    exit: {
        y: '100%',
        opacity: 0,
    },
};
var FadeUp = function (_a) {
    var children = _a.children;
    return (<AnimatePresence>
      <motion.div variants={fadeUp}>
        {children}
      </motion.div>
    </AnimatePresence>);
};
export default FadeUp;
